import React from "react";
import Tile from "./Tile.js";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { trackView } from "@dc/utag-tracking";

const Tiles = ({ heading, discoverTilesData }) => {
  const history=useHistory()
  return (
    <section className="section section--wild-sand">
      <div className="spring">
        <h3 className="heading heading--4 section__title">{heading}</h3>
        <div className="grid tiles">
          <div className="grid__item tiles__item tiles__item--1/2 grid__item--1/2 grid__item--sm-1/1">
            <Tile
              className={discoverTilesData[0].className}
              tileInfo={discoverTilesData[0].tileInfo}
              imageUrl={discoverTilesData[0].imageUrl}
              onClickHandler={()=>{history.push("?i_code=consumer-home-discover_banner-best_tv_and_box_set");trackView()}}
            />
          </div>
          <div className="grid__item tiles__item grid__item--1/2 grid__item--sm-1/1">
            <div className="grid__item grid__item--1/1">
              <Tile
                className={discoverTilesData[1].className}
                tileInfo={discoverTilesData[1].tileInfo}
                imageUrl={discoverTilesData[1].imageUrl}
              />
            </div>
            <div className="grid__item grid__item--1/1">
              <Tile
                className={discoverTilesData[2].className}
                tileInfo={discoverTilesData[2].tileInfo}
                imageUrl={discoverTilesData[2].imageUrl}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Tiles.propTypes = {
  heading: PropTypes.string.isRequired,
  discoverTilesData: PropTypes.array.isRequired,
};

export default Tiles;
